import React from "react";
import { Row, Col } from "react-bootstrap";
import { CommonInput, CommonSelect } from "../../Input";
import DetailFieldWrapper from "./DetailFieldWrapper";

const Step2PaymentInfo = () => {
  return (
    <div className="mt-4">
      <Row className="mb-4">
        <Col md={6}>
          <DetailFieldWrapper label="Send Currency">
            <CommonSelect
              placeholder="Singapore Dollar"
              options={[{ value: "SGD", label: "Singapore Dollar" }]}
            />
          </DetailFieldWrapper>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Receiving Currency">
            <CommonSelect
              placeholder="Philippine Peso"
              options={[{ value: "PHP", label: "Philippine Peso" }]}
            />
          </DetailFieldWrapper>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6}>
          <DetailFieldWrapper label="Purpose of Transfer">
            <CommonSelect
              placeholder="Payroll"
              options={[{ value: "payroll", label: "Payroll" }]}
            />
          </DetailFieldWrapper>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Source of Funds">
            <CommonSelect
              placeholder="Savings"
              options={[{ value: "savings", label: "Savings" }]}
            />
          </DetailFieldWrapper>
        </Col>
      </Row>

      <Row className="mb-1">
        <Col md={6}>
          <DetailFieldWrapper label="Transfer Amount">
            <div className="d-flex align-items-center bg-light border rounded px-2">
              <span className="text-muted me-2 fs-12">SGD</span>
              <input
                type="text"
                className="form-control border-0 bg-transparent py-2"
                defaultValue="2,743"
              />
            </div>
          </DetailFieldWrapper>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Receive Amount">
            <div className="d-flex align-items-center bg-light border rounded px-2">
              <span className="text-muted me-2 fs-12">PHP</span>
              <input
                type="text"
                className="form-control border-0 bg-transparent py-2"
                defaultValue="100"
              />
            </div>
          </DetailFieldWrapper>
        </Col>
      </Row>
      <div className="text-muted fs-11 mb-4">1 SGD = 36.45 PHP</div>

      <Row className="mb-4">
        <Col md={6}>
          <DetailFieldWrapper label="Fee">
            <div className="d-flex align-items-center bg-light border rounded px-2">
              <span className="text-muted me-2 fs-12">SGD</span>
              <input
                type="text"
                className="form-control border-0 bg-transparent py-2"
                defaultValue="6"
                disabled
              />
            </div>
          </DetailFieldWrapper>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Remark (optional)">
            <CommonInput placeholder="Enter remark" />
          </DetailFieldWrapper>
        </Col>
      </Row>
    </div>
  );
};

export default Step2PaymentInfo;
